import { defineMessage, AudienceFilter, defineTopic } from 'magpie-lib/models';
import * as t from 'ts-schema';
const insertVideoMessage = defineMessage({
  type: '@@video-components-external/utility/insert-video',
  payloadSchema: t.object({
    video: t.object({
      sourceFileId: t.number
    })
  })
});
const bulkInsertVideosMessage = defineMessage({
  type: '@@video-components-external/utility/bulk-insert-videos',
  payloadSchema: t.object({
    videos: t.array(t.object({
      sourceFileId: t.number
    }))
  })
});
const videoDeletedMessage = defineMessage({
  type: '@@video-components-external/video-management/video-deleted',
  payloadSchema: t.object({
    sourceFileId: t.number,
    videoTitle: t.string
  })
});
const clipPublishedMessage = defineMessage({
  type: '@@video-components-external/video-management/clip-published',
  payloadSchema: t.object({
    renderId: t.number
  })
});

// Deprecated: Use clipPublishedMessage instead
// Kept for backwards compatibility with content-media-composition
const variantPublishedMessage = clipPublishedMessage;
const notifyUserMessage = defineMessage({
  type: '@@video-components-external/video-management/notify-user',
  payloadSchema: t.custom('UserNotificationPayload', value => {
    return typeof value === 'object' && value !== null && 'type' in value;
  })
});
const videoPanelClosedMessage = defineMessage({
  type: '@@video-components-external/video-management/video-panel-closed',
  payloadSchema: t.object({})
});
export const VideoManagementMessages = {
  insertVideoMessage,
  bulkInsertVideosMessage,
  clipPublishedMessage,
  variantPublishedMessage,
  // Deprecated: Use clipPublishedMessage
  notifyUserMessage,
  videoDeletedMessage,
  videoPanelClosedMessage
};
export const videoManagementTopicDef = defineTopic({
  name: '@@video-components-external/video-management',
  messages: [VideoManagementMessages.insertVideoMessage, VideoManagementMessages.bulkInsertVideosMessage, VideoManagementMessages.clipPublishedMessage, VideoManagementMessages.notifyUserMessage, VideoManagementMessages.videoDeletedMessage, VideoManagementMessages.videoPanelClosedMessage],
  enableRuntimeValidation: false,
  audience: AudienceFilter.builder().build()
});